module.exports = "https://static.wagwalking.com/_next/static/images/pet-7-bd18ce6cbdaa5f9a3eb6d7de59fe1fe5.png";